<template>
  <div>
    <md-checkbox
      v-model="check"
      @change="storeAvailableOnlyToMyGroups"
      class="md-primary"
      :class="{ 'is-checked': check, 'is-not-checked': !check }"
      :data-cy="`${dataCy}-newItemToGroups-checkbox`"
      >Post this item only in my groups</md-checkbox
    >
  </div>
</template>

<script>
import ItemHelperVue from "../../mixins/ItemHelper.vue";
export default {
  name: "CheckItemAtMyGroups",
  props: ["dataCy", "isEditPage"],
  mixins: [ItemHelperVue],
  data() {
    return {
      check: true,
    };
  },
  methods: {
    storeAvailableOnlyToMyGroups() {
      this.setNewItemAvailableOnlyToGroups(this.check);
    },
  },
  mounted() {
    setTimeout(() => {
      if(this.isEditPage){         
        this.check = this.itemProfile.availableOnlyToGroups;        
      }else { 
        this.check = this.availableOnlyToGroups
      }
    }, 2000); 
  }
};
</script>
